import type { ComponentProps } from "react";

import { LogoIcon } from "./logo-icon";

import { cn } from "~/shared/ui";

type Props = ComponentProps<"div">;

function Logo({ className, ...props }: Props) {
  return (
    <div
      className={cn(
        "text-primary-foreground bg-primary flex size-12 items-center justify-center rounded-full text-xl font-bold",
        className,
      )}
      {...props}
    >
      <LogoIcon bodyClassName="fill-primary-foreground" tireClassName="stroke-primary-foreground" />
    </div>
  );
}

export { Logo };
